import script from "./z-header.vue?vue&type=script&setup=true&lang=js"
export * from "./z-header.vue?vue&type=script&setup=true&lang=js"

import "./z-header.vue?vue&type=style&index=0&id=4dc86a0d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc86a0d"]])

export default __exports__